import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";
import React from "react";

const StoriesViewer = () => {
  const stories = useDesignSystemStore(
    (state) => state.generation.context.stories
  );

  const status = useDesignSystemStore((state) => state.generation.status);

  let accordionProps = {};

  if (status === GenerationStatus.GeneratingContext) {
    accordionProps = {
      value: `item-${stories.length - 1}`,
    };
  }

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full text-2xs"
      {...accordionProps}
    >
      {stories.map((story: any, index) => (
        <AccordionItem key={index} value={`item-${index}`}>
          <AccordionTrigger className="text-3xs py-2 font-bold text-secondary-800 items-center group">
            <div className="flex flex-row gap-1 items-center">
              <span>{story.name}</span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="py-2">
            <div className="flex flex-col ">
              <div className="text-2xs">{story.description}</div>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default React.memo(StoriesViewer);
